import { IgTypography } from "@intelligems/ig-theme";
import { LivePriceDto } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { IntegerCurrencyFormat } from "@src/features/admin/components/utils";

interface PriceRowProps {
  price: LivePriceDto;
}
export const PriceRow = ({ price }: PriceRowProps) => {
  const theme = useTheme();
  return (
    <Grid container item direction={"column"} rowSpacing={1}>
      <Grid container item>
        <Grid item>
          <IgTypography>
            <IgTypography
              variant={"display"}
              color={theme.palette.text.secondary}
              sx={{ fontWeight: 600 }}
            >
              {IntegerCurrencyFormat.format(
                price.interval === "year" ? price.price / 12 : price.price
              )}
            </IgTypography>{" "}
            <IgTypography
              variant={"body2"}
              sx={{
                color: theme.palette.text.secondary,
                fontWeight: 400,
                paddingLeft: "10px",
              }}
            >
              per month
            </IgTypography>
            {price.comparePrice ? (
              <IgTypography
                variant={"h1"}
                sx={{
                  color: theme.palette.text.secondary,
                  fontWeight: 600,
                  textDecorationLine: "line-through",
                }}
              >
                {" "}
                {IntegerCurrencyFormat.format(price.comparePrice)}
              </IgTypography>
            ) : null}
          </IgTypography>
        </Grid>
      </Grid>
      <Grid item sx={{ height: "22px" }}>
        {price.interval === "year" ? (
          <IgTypography
            sx={{ color: theme.palette.text.secondary, fontWeight: 600 }}
          >
            Billed at {IntegerCurrencyFormat.format(price.price)} per year
          </IgTypography>
        ) : null}
      </Grid>
    </Grid>
  );
};
